export default {
  search: {
    start: null,
    end: null,
  },
  activeTab: 'instant',
  kw: '',
  rule: 0,
  // 立即單
  instantList: {},
  instantPick: 0,
  instantPaging: {
    currentPage: 1,
    npp: 25,
    totalPages: 1,
    totalEntries: 0,
  },
  // 路招單
  roadList: {},
  roadPaging: {
    currentPage: 1,
    npp: 25,
    totalPages: 1,
    totalEntries: 0,
  },
  // 預約前派單
  reserveBeforeList: {},
  reserveBeforePaging: {
    currentPage: 1,
    npp: 25,
    totalPages: 1,
    totalEntries: 0,
  },
  // 預約後派單
  reserveAfterList: {},
  reserveAfterPaging: {
    currentPage: 1,
    npp: 25,
    totalPages: 1,
    totalEntries: 0,
  },
  // 機場接送
  airportTransferList: [],
  airportTransferPaging: {
    currentPage: 1,
    npp: 25,
    totalPages: 1,
    totalEntries: 0,
  },
}



// WEBPACK FOOTER //
// ./src/store/transaction/state.js